module.exports = __webpack_public_path__ + "static/media/Bedroom.856b1d22.webp";